<template>

    <div>
        <el-card shadow="hover"  class="searchCard" >
             <span class="label-span">
                <label class="label">员工名称</label>
                <el-input v-model.trim="query.loginName" placeholder="员工名称" class="handle-input mr10"></el-input>
            </span>
            <span class="label-span">
                <label class="label">员工状态</label>
                <el-select v-model="query.status"  placeholder="员工状态" clearable class="handle-select mr10">
                    <el-option value="" label="全部"  />
                    <el-option value="1" label="启用"  />
                    <el-option value="0" label="停用"  />
                </el-select>
            </span>
            <el-button icon="el-icon-search" class='mr10' @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" class='mr10' @click="refreshSearch">重置</el-button>
            <el-button icon="el-icon-lx-roundadd" class='mr10' @click="handleAdd" >添加员工</el-button>



        </el-card>
        <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="id" width="60" align="center" label="ID"></el-table-column>
                <el-table-column prop="phone"  min-width="115" align="center" label="手机号码"></el-table-column>
                <el-table-column prop="loginName"   min-width="120" align="left" label="员工名称"></el-table-column>
                <el-table-column prop="pid"   min-width="120" align="left" label="员工岗位">
                    <template slot-scope="scope" >
                        <span v-for="item in select.option" v-if='scope.row.pid==item.optKey'>
                            {{item.optVal}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" min-width="80" align="center" label="员工状态">
                    <template slot-scope="scope" >
                        <el-tooltip :content="scope.row.status=='1'?'员工已开启':'员工已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                       v-model="scope.row.status"
                                       active-color=""
                                       inactive-color="red"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime"  min-width="160" align="center"  label="创建时间"> </el-table-column>
                <el-table-column prop="updateTime"  min-width="160" align="center"  label="更新时间"> </el-table-column>
                <el-table-column label="操作" min-width="180" align="center"  fixed="right">
                    <template slot-scope="scope">
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建自主员工弹出框 -->
        <el-dialog title="添加" :visible.sync="addVisible" :before-close="done=>handleClose(done,'form1')"
                   :modal-append-to-body='false' :close-on-click-modal="false" top="80px" width="500px">
            <el-form ref="form1" :rules="rules" :model="form1" label-width="80px">
                <el-form-item prop="loginName" label="员工名称" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form1.loginName"  placeholder="请输入修改员工名称"></el-input>
                </el-form-item>
                <el-form-item prop="phone" label="手机号码"  style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form1.phone" type="number" placeholder="请输入修改手机号" oninput ="value=value.replace(/[^\d]/g,'')"></el-input>
                </el-form-item>
                <el-form-item prop="loginPass" label="登录密码" style="width:50%;display:inline-block;"  >
                    <el-input  v-model.trim="form1.loginPass"  placeholder="不更改留空"  ></el-input>
                </el-form-item>
                <el-form-item prop="rcode" label="绑定角色" style="width:50%;display:inline-block;">
                    <el-select v-model.trim="form1.rcode"  placeholder="选择角色" filterable clearable >
                        <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item prop="pid" label="员工岗位" style="width:50%;display:inline-block;">
                    <el-select v-model.trim="form1.pid"  placeholder="选择岗位" filterable clearable >
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm('form1')">取 消</el-button>
                <el-button type="primary" @click="saveForm('form1')">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>

        <!-- 编辑自主员工弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible"
                   :modal-append-to-body='false' :close-on-click-modal="false" top="50px" width="500px">
            <el-form ref="form2" :rules="rules" :model="form2" label-width="80px">
                <el-form-item prop="loginName" label="员工名称" style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form2.loginName"  placeholder="请输入修改员工名称"></el-input>
                </el-form-item>
                <el-form-item prop="phone" label="手机号码"  style="width:50%;display:inline-block;" >
                    <el-input  v-model.trim="form2.phone" type="number" placeholder="请输入修改手机号" oninput ="value=value.replace(/[^\d]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="登录密码" style="width:50%;display:inline-block;"  >
                    <el-input  v-model.trim="form2.loginPass"  placeholder="不更改留空"  ></el-input>
                </el-form-item>
                <el-form-item prop="rcode" label="绑定角色" style="width:50%;display:inline-block;">
                    <el-select v-model.trim="form2.rcode"  placeholder="选择角色" filterable clearable >
                        <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item prop="pid" label="员工岗位" style="width:50%;display:inline-block;">
                    <el-select v-model.trim="form2.pid"  placeholder="选择岗位" filterable clearable >
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit('form2')">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from './comUser';
import {fetchSelect} from './comUserPer';
import {fetchSelect as fetchSelect1} from '../../api/operRole';
export default {
    data() {
        return {
            rules: {
                loginName: [
                    { required: true, message: '请输入员工名称', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' }
                ],
                loginPass: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' }
                ],
                rcode: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ],
                pid: [
                    { required: true, message: '请选择员工岗位', trigger: 'change' }
                ]
            },
            isSubmitting: false, // 是否正在提交
            select:{ option:'',  },
            select1:{ option:'',  },
            query: {
                pageIndex: 1,
                pageSize: 10,
            },
            multipleSelection:[],
            tableData: [],
            pageTotal: 0,
            editVisible: false,
            addVisible: false,
            form: {  },
            form1: {loginName:'',phone:'',loginPass:'yxwl@123',rcode:'',pid:''},
            form2: {loginName:'',phone:'',loginPass:'',rcode:'',pid:''},
            id: -1
        };
    },
    created() {

    },
    //页面加载方法
    mounted: function () {
        //查询列表
        this.getSelect();
        this.getSelect1();
        this.getData();
    },

    methods: {
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'loginName', '');
            this.$set(this.query, 'status','');
            this.handleSearch();
        },
        //触发刷新按钮
        refresh(){
            history.go(0);
        },

        //查询
        getData(){
            this.multipleSelection = [];
            fetchData(this.query).then(res => {
                if(res.code=='200'){
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;
                }else{
                    this.tableData = [];
                    this.pageTotal = 0;
                }

            });
        },

        handleClose(done,formName) {
            this.resetForm(formName);
            done();
        },

        resetForm(formName) {
            this.addVisible = false;
            this.$refs[formName].resetFields();
        },
        // 添加员工
        handleAdd() {
            this.addVisible = true;
        },
        //保存添加
        saveForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.addVisible = false;
                    saveForm(this.form1).then(res => {
                        this.addVisible = false;
                        this.loading = false;
                        this.isSubmitting = false;
                        if(res.code=='200'){
                            this.$message.success(res.message);
                            this.refreshSearch();
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            });
        },

        // 编辑操作
        handleEdit(index, row) {
            this.form2 = row;
            this.form2.loginPass = "";
            this.editVisible = true;
        },
        // 保存更改
        saveEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    changeForm(this.form2).then(res => {
                        if(res.code=='200'){
                            this.editVisible = false;
                            this.$message.success(res.message);
                            this.getData();
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {
            var tips ;
            var content;
            if(row.status=='0'){
                row.status='1'
                tips = "禁用";
                content = "确定禁用吗？";
            }else{
                row.status='0'
                tips = "启用";
                content = "确定启用吗？";
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => {
                if(row.status=='0'){
                    row.status='1'
                }else{
                    row.status='0'
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success(tips+'成功');
                        this.getData();
                    }else{
                        if(row.status=='0'){
                            row.status='1'
                        }else{
                            row.status='0'
                        }
                        this.$message.error(tips+'失败');
                    }
                });
            })
        },
        // 删除
        handDelete(index, row) {
            // 二次确认删除
            this.$confirm('该员工所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success('删除成功');
                        this.$set(this.query, 'pageIndex', 1);
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该员工商品仍有订单未结算，请手动结算订单！");
                    }else{
                        this.$message.error("删除失败");
                    }
                });
            })
        },

        getSelect(){
            this.select = {};
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.$set(this.select, 'option', res.data);
                }
            });
        },

        getSelect1(){
            this.select = {};
            fetchSelect1(this.select1).then(res => {
                if(res.code=='200'){
                    this.$set(this.select1, 'option', res.data);
                }
            });
        },

        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val) {
            this.$set(this.query, 'pageSize', val);
            this.handleSearch();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
    }
};
</script>

<style scoped>

</style>
